import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router';
import { VehicleSelector } from 'components/containers/common/VehicleSelector';
import { MenuSelection } from 'components/views/organisms/SidebarMenu';
import { useSelectMenu } from 'services/useSelectedMenu';
import { CockpitPage } from '../../CockpitPage';
import { DashboardPage } from '../../DashboardPage';
import { DrivePage } from '../../DrivePage';
import { ignore } from 'utility/ignore';
import { SettingsPage } from '../../SettingsPage';
import { NotFoundPage } from '../../NotFoundPage';
import { ClockPage } from '../../ClockPage/ClockPage';
import { RTCPage } from '../../RTCPage/RTCPage';

function UpdateMenu(props: React.PropsWithChildren<{ name: MenuSelection }>) {
    const { children, name } = props;

    const selectMenu = useSelectMenu();
    useEffect(() => {
        selectMenu(name);
    }, [name, selectMenu]);

    return <>{children}</>;
}

export type ContentSelectorProps = {
};

export function ContentSelector(props: ContentSelectorProps) {
    ignore(props);

    const navigate = useNavigate();

    return (
        <Routes>
            <Route path='' element={<Navigate to='dashboard' />} />
            <Route path='dashboard'
                element={
                    <UpdateMenu name='Dashboard'>
                        <DashboardPage onVehicleSelect={vehicle => navigate(`../console/drive/${vehicle.id}`)} />
                    </UpdateMenu>
                }
            />
            <Route path='drive'>
                <Route path=''
                    element={
                        <UpdateMenu name='Drive'>
                            <VehicleSelector title='Grid Mode' />
                        </UpdateMenu>
                    }
                />
                <Route path=':vehicleId'
                    element={
                        <UpdateMenu name='Drive'>
                            <DrivePage />
                        </UpdateMenu>
                    }
                />
            </Route>
            <Route path='cockpit'>
                <Route path=''
                    element={
                        <UpdateMenu name='Cockpit'>
                            <VehicleSelector title='Full Screen Mode' />
                        </UpdateMenu>
                    }
                />
                <Route path=':vehicleId'
                    element={
                        <UpdateMenu name='Cockpit'>
                            <CockpitPage />
                        </UpdateMenu>
                    }
                />
            </Route>
            <Route path='rtc'>
                <Route path='' element={
                    <UpdateMenu name='RTC'>
                        <VehicleSelector title='RTC Mode' />
                    </UpdateMenu>
                } />
                <Route path=':vehicleId' element={
                    <UpdateMenu name='RTC'>
                        <RTCPage />
                    </UpdateMenu>
                } />
            </Route>
            <Route path='setting'>
                <Route path=''
                    element={
                        <UpdateMenu name='Setting'>
                            <Navigate to='layout' replace={true} />
                        </UpdateMenu>
                    }
                />
                <Route path='layout'>
                    <Route path=''
                        element={
                            <UpdateMenu name='Setting'>
                                <VehicleSelector title='Camera Layout Settings' />
                            </UpdateMenu>
                        }
                    />
                    <Route path=':vehicleId'
                        element={
                            <UpdateMenu name='Setting'>
                                <SettingsPage onBack={() => navigate(-1)} />
                            </UpdateMenu>
                        }
                    />
                </Route>
            </Route>
            <Route path='clock' element={<ClockPage />} />
            <Route path='*' element={<NotFoundPage />} />
        </Routes>
    );
}
